import moment from 'moment';
import { valueExists } from '../utils';

const styleSalesLastXDays = ({
	salesLast7Days,
	salesLast14Days,
	salesLast30Days,
	salesLast365Days,
	planogramItemDaysSinceLastSale,
	planogramItemSalesLastXDaysThresholds,
	lastProductChangeTime,
	created,
	daysSinceLastSale,
}) => {

	const createdDate = moment(created);
	const lastProductChangeDate = lastProductChangeTime ? moment(lastProductChangeTime) : null;
	const lastProductDaysSinceLastSaleDate = moment.utc().subtract(planogramItemDaysSinceLastSale, 'days');

	// check if planogramItem had been created more than 30 days ago
	// check if planogramItem had had product change more than 30 days ago
	const lastProductChangeCheck = createdDate <= lastProductDaysSinceLastSaleDate &&
		(!lastProductChangeDate || lastProductChangeDate <= lastProductDaysSinceLastSaleDate);

	const salesLastXDays = getSalesXDays({
		salesLast7Days,
		salesLast14Days,
		salesLast30Days,
		salesLast365Days,
		planogramItemDaysSinceLastSale,
	});
	let backgroundStyle;
	let borderStyle;

	if (daysSinceLastSale === planogramItemDaysSinceLastSale || !valueExists(daysSinceLastSale)) {
		backgroundStyle = {
			planogramRedFooter: salesLastXDays < planogramItemSalesLastXDaysThresholds[0] && lastProductChangeCheck, // red
			planogramAmberFooter: salesLastXDays >= planogramItemSalesLastXDaysThresholds[0] && salesLastXDays < planogramItemSalesLastXDaysThresholds[1] && lastProductChangeCheck, // amber
			planogramGreenFooter: salesLastXDays >= planogramItemSalesLastXDaysThresholds[1] && lastProductChangeCheck, // green
			markerColor2: !lastProductChangeCheck, // grey
		};

		borderStyle = {
			planogramItemLowQuantity: backgroundStyle.planogramRedFooter, // red
			label3: backgroundStyle.planogramAmberFooter, // amber
			planogramItemHighQuantity: backgroundStyle.planogramGreenFooter, // green
			markerColor2: backgroundStyle.markerColor2, // grey
		};
	}
	return ({
		lastProductChangeCheck,
		salesLastXDays,
		borderStyle,
		backgroundStyle,
	});
};


const getSalesXDays = ({
	salesLast7Days,
	salesLast14Days,
	salesLast30Days,
	salesLast365Days,
	planogramItemDaysSinceLastSale,
}) => {
	let salesLastXDays = null;
	if (planogramItemDaysSinceLastSale === 7 && valueExists(salesLast7Days)) {
		salesLastXDays = salesLast7Days;
	}
	else if (planogramItemDaysSinceLastSale === 14 && valueExists(salesLast14Days)) {
		salesLastXDays = salesLast14Days;
	}
	else if (planogramItemDaysSinceLastSale === 30 && valueExists(salesLast30Days)) {
		salesLastXDays = salesLast30Days;
	}
	else if (planogramItemDaysSinceLastSale === 365 && valueExists(salesLast365Days)) {
		salesLastXDays = salesLast365Days;
	}
	else {
		salesLastXDays = salesLast7Days || salesLast14Days || salesLast30Days || salesLast365Days || 0;
	}

	return salesLastXDays;
};

export default styleSalesLastXDays;
